<template>
  <div class="agregar-carro">


  </div>
</template>

<script>

  import axios from 'axios';
  import {uuid} from 'vue-uuid';
  import {URL_CARRO, URL_SERVER, URL_SUCURSAL} from "../../../api/config";

  export default {
    name: "agregarAlCarro",
    props: {
      producto: null,
      show: false,
    },
    data() {
      return {
        sucursales: this.$store.getters.sucursales,
        sucursal: '',
        tipo: '',
        id: uuid.v4(),
      }
    },
    methods: {
      agregar() {
        this.$emit('addToBasket')
      },

    }
  }
</script>

<style scoped lang="scss">

  select {
    margin-bottom: 5px;
  }


</style>
